import { ADD_PATIENT } from "./types";

let initialState = {
    patients: [],
};

const patientReducer = (state = initialState,action) => {
    switch (action.type) {
        case ADD_PATIENT:
            return {
                ...state,
                patients: [...state.patients, action.payload]
            };
        default:
            return state;
    }
}

export default patientReducer;